import {specimenType} from "../../utils/const";
import axios from "axios";
import querystring from "query-string";
import {RegionSelectionConstants} from "../../redux_constants/region_selection.constant";
import {getStateAwareUrl} from "../../utils/utils";

export function getPreviewLocation (slot, tray, rack) {

    slot === undefined ? slot = 0 : slot = slot;
    tray === undefined ? tray = 0 : tray = tray;
    rack === undefined ? rack = 0 : rack = rack;

    return getStateAwareUrl('/dev-ssd/scans_preview/S'+ (slot+1) + 'T' + (tray) + 'R' + (rack))
}

export function getBarcode (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/barcode.jpg'
}

export function getBarcodeCrop (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/barcode_crop.jpg'
}

export function getMaskForFocusLevelZero (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/mask_for_focus_level_0.jpg'
}

export function getMaskForFocusLevelOne (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/mask_for_focus_level_1.jpg'
}

export function getMaskForFocusLevelTwo (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/mask_for_focus_level_2.jpg'
}

export function getMaskForPath (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/mask_for_path.bmp'
}

export function getOverlayedMaskForFocusLevelZero (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/overlayed_mask_for_focus_level_0.jpg'
}

export function getOverlayedMaskForFocusLevelOne (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/overlayed_mask_for_focus_level_1.jpg'
}

export function getOverlayedMaskForFocusLevelTwo (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/overlayed_mask_for_focus_level_2.jpg'
}

export function getOverlayedMaskForPath (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/overlayed_mask_for_path.jpg'
}

export function getDefaultOverlayedMaskForSpecimen (specimen, slot, tray, rack ) {
	let specType = specimen.toLowerCase()
	if (specType === specimenType.HNE_TISSUE.toLowerCase()){
		specType = "hne"
	} else if (specType === specimenType.BM.toLowerCase()){
        specType = "bone_marrow"
    }
	return getPreviewLocation(slot, tray, rack) + `/pre-processed/default_overlayed_mask_for_path_${specType}.jpg`
}

export function getRaw (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/raw.jpg'
}

export function getRotatedThumbnail (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/rotated_thumbnail.jpg'
}

export function getStitchedSmall (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/stitched_small.jpg'
}

export function getStitchedSmallViewer (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/stitched_small_viewer.jpg'
}

export function getUncropped (slot, tray, rack) {
    return getPreviewLocation(slot, tray, rack) + '/pre-processed/uncropped.jpg'
}

let cancelToken;

// Get the calculated area for selected preview region
export const getAreaFromBoundingBox = (reg, previewHeight, previewWidth, slot, device_id, cbUpdateArea) => {
    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.")
    }

    //Save the cancel token for the current request
    cancelToken = axios.CancelToken.source()

    let url = `/server/devices/${device_id}/get_area_mm_from_bounding_box/`;
    if (reg !== undefined) {
        const x1 = parseInt((reg.x * previewWidth) / 100.0);
        const x2 = parseInt(((reg.x + reg.width) * previewWidth) / 100.0);
        const y1 = parseInt((reg.y * previewHeight) / 100.0);
        const y2 = parseInt(((reg.y + reg.height) * previewHeight) / 100.0);
        const data = {
            'slot_id': slot,
            'top_x': x1,
            'top_y': y1,
            'bottom_x': x2,
            'bottom_y': y2
        };
        axios.post(getStateAwareUrl(url), querystring.stringify(data), { cancelToken: cancelToken.token }).then(res => {
            cbUpdateArea(res.data.toFixed(0))
        }).catch(err => {
            console.log(err);
        });
    }
}

export const isMonolayerDone = (previewStatusForId) => {
    return (previewStatusForId && (previewStatusForId.previewStage === RegionSelectionConstants.COARSE_DONE ||
        previewStatusForId.previewStage === RegionSelectionConstants.CONFIRMED))
}

